package game.controller

import com.soywiz.korge.input.Input
import game.Game
import game.ROOM_WIDTH
import view.Terminal

class GameOverController : GameController() {
    private var coolDown = 150.0
    private var step = 0
    private var transitionDuration = ROOM_WIDTH.toDouble() * 0.5
    private val ratio: Double
        get() = (transitionDuration - coolDown) / transitionDuration

    override fun onRender(game: Game, terminal: Terminal) {
        game.renderAll(terminal)

        when (step) {
            1 -> {
                val radius = ((1.0 - ratio) * ROOM_WIDTH).toInt()
                game.renderCircle(terminal, radius, game.player.col, game.player.row)
            }
            2 -> {
                val radius = (ratio * ROOM_WIDTH).toInt()
                game.renderCircle(terminal, radius, game.player.col, game.player.row)
            }
        }
    }

    override fun onTick(game: Game, input: Input) {
        when (step) {
            0 -> {
                coolDown--

                if (coolDown <= 0) {
                    step++
                    coolDown = transitionDuration
                    game.playSound("teleport")
                }
            }
            1 -> {
                coolDown--

                if (coolDown <= 0) {
                    step++
                    coolDown = transitionDuration
                    game.loadGame()
                    game.controller = this
                }
            }
            2 -> {
                coolDown--

                if (coolDown <= 0)
                {
                    game.controller = PlayController()
                }
            }
        }
    }
}
